import localforage from 'localforage';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import {
  QueryClient,
  defaultShouldDehydrateQuery,
} from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// create an async persister around localForage
const asyncStoragePersister = createAsyncStoragePersister({
  storage: localforage,
  throttleTime: 1000,
});

persistQueryClient({
  queryClient,
  persister: asyncStoragePersister,
  maxAge: Infinity,
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => {
      // Exclude any query whose key starts with `'lenderFromHook'`
      return (
        defaultShouldDehydrateQuery(query) &&
        query.queryKey[0] !== 'lenderFromHook'
      );
    },
  },
});

export default queryClient;
